import { render, staticRenderFns } from "./SearchHistory2020.vue?vue&type=template&id=89bd0e44&scoped=true&"
import script from "./SearchHistory2020.vue?vue&type=script&lang=js&"
export * from "./SearchHistory2020.vue?vue&type=script&lang=js&"
import style0 from "./SearchHistory2020.vue?vue&type=style&index=0&id=89bd0e44&prod&lang=css&"
import style1 from "@/css/a.css?vue&type=style&index=1&id=89bd0e44&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bd0e44",
  null
  
)

export default component.exports